import { useState } from 'react';
import { Alert, AlertColor, Snackbar } from '@mui/material';

let showToastFunction: (message: string, severity: AlertColor) => void;

export const ToastMessage = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<AlertColor>('info');

  showToastFunction = (msg: string, sev: AlertColor) => {
    setMessage(msg);
    setSeverity(sev);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Alert severity={severity} onClose={handleClose}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export const showToast = (message: string, type: AlertColor = 'info') => {
  if (showToastFunction) {
    showToastFunction(message, type);
  } else {
    console.warn('Toast component not mounted - call showToast after rendering <Toast />');
  }
};